import React from "react";
import { FaXmark } from "react-icons/fa6";
import { HiOutlineExclamationCircle } from "react-icons/hi";
export default function AreYouSureModal({ message, closeModal, okayButton }) {
  return (
    <main className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <section className="w-[24rem] h-auto flex flex-col items-start justify-start bg-white rounded gap-1">
        <header className="flex w-full p-2 items-center justify-end rounded-t-lg font-medium">
          <button onClick={closeModal}>
            <FaXmark />
          </button>
        </header>
        <section className="w-full flex flex-col text-center text-base text-[#f85353] p-2 font-medium">
          <div className="w-full flex items-center justify-center text-lg">
            <HiOutlineExclamationCircle className="text-[#f85353] text-center text-4xl" />
          </div>
          {message}
        </section>
        <footer className="flex justify-end items-center w-full p-2">
          <button
            className="border py-1 px-2 tracking-wide mr-2 text-gray-700 hover:bg-gray-100 rounded"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            className={`border py-1 px-2 tracking-wide bg-[#f85353] text-white rounded`}
            onClick={okayButton}
          >
            Okay
          </button>
        </footer>
      </section>
    </main>
  );
}
